function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
export default ({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  width: "682",
  height: "655",
  viewBox: "0 0 682 655",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), /*#__PURE__*/React.createElement("path", {
  opacity: ".1",
  d: "M0 299.084a33.527 33.527 0 0111.597-25.38L319.33 8.07c12.465-10.76 30.876-10.76 43.342 0l307.732 265.634A33.525 33.525 0 01682 299.084v322.467C682 640.025 667.106 655 648.732 655H214.779c-38.016 0-46.299-53.766-10.065-65.329l259.462-82.804c13.819-4.408 23.204-17.306 23.204-31.883v-80.89a33.53 33.53 0 00-11.201-25.03l-113.644-101.28c-12.366-11.019-30.899-11.245-43.525-.532L54.724 491.494C33.094 509.848 0 494.388 0 465.933V299.084z",
  fill: "#fff"
}));